const REQUIRED_ENV_VARS = [
  'REACT_APP_APPWRITE_ENDPOINT',
  'REACT_APP_APPWRITE_PROJECT_ID',
  'REACT_APP_API_URL',
  'REACT_APP_BUCKET_ID',
];

const getEnvValue = (key) => process.env[key]?.trim();

const missingEnvVars = REQUIRED_ENV_VARS.filter((key) => !getEnvValue(key));

if (missingEnvVars.length > 0) {
  throw new Error(
    `Missing required environment variable(s): ${missingEnvVars.join(', ')}`
  );
}

if (
  process.env.NODE_ENV === 'production' &&
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(getEnvValue('REACT_APP_API_URL'))
) {
  throw new Error('REACT_APP_API_URL must not point to localhost in production builds.');
}

export const env = {
  appwriteEndpoint: getEnvValue('REACT_APP_APPWRITE_ENDPOINT'),
  appwriteProjectId: getEnvValue('REACT_APP_APPWRITE_PROJECT_ID'),
  apiUrl: getEnvValue('REACT_APP_API_URL'),
  bucketId: getEnvValue('REACT_APP_BUCKET_ID'),  
};
